import React from 'react';
import { Button, Chip, Stack, TextField, Typography } from '@mui/material';
import { AppDialog } from './AppDialog';
import { PeoplePicker } from './PeoplePicker';

type ShareChatDialogProps = {
  open: boolean;
  onClose: () => void;
  addShareChatRecipient: (value: string) => void;
  shareChatRecipients: string[];
  setShareChatRecipients: React.Dispatch<React.SetStateAction<string[]>>;
  shareChatSubject: string;
  setShareChatSubject: (next: string) => void;
  shareChatSending: boolean;
  sendChatShare: () => void;
  downloadChatExport: () => void;
};

export function ShareChatDialog({
  open,
  onClose,
  addShareChatRecipient,
  shareChatRecipients,
  setShareChatRecipients,
  shareChatSubject,
  setShareChatSubject,
  shareChatSending,
  sendChatShare,
  downloadChatExport,
}: ShareChatDialogProps) {
  const peoplePickerRef = React.useRef<HTMLInputElement>(null);
  return (
    <AppDialog
      open={open}
      onClose={onClose}
      title="Chatverlauf exportieren"
      maxWidth="sm"
      fullWidth
      dialogProps={{
        disableAutoFocus: true,
        disableEnforceFocus: true,
        disableRestoreFocus: true,
        TransitionProps: {
          onEntered: () => {
            peoplePickerRef.current?.focus();
            peoplePickerRef.current?.select?.();
          },
        },
      }}
      actions={(
        <>
          <Button onClick={onClose}>Abbrechen</Button>
          <Button
            variant="outlined"
            onClick={downloadChatExport}
            disabled={shareChatSending}
          >
            Download
          </Button>
          <Button
            variant="contained"
            disabled={shareChatSending || shareChatRecipients.length === 0}
            onClick={sendChatShare}
          >
            {shareChatSending ? 'Sende...' : 'Senden'}
          </Button>
        </>
      )}
    >
      <Stack spacing={2} sx={{ mt: 1 }}>
        <PeoplePicker
          label="Empfänger (Name oder E-Mail)"
          onChange={addShareChatRecipient}
          disabled={shareChatSending}
          inputRef={peoplePickerRef}
        />
        {shareChatRecipients.length > 0 && (
          <Stack spacing={1}>
            <Typography variant="caption" color="text.secondary">
              Empfänger:
            </Typography>
            <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
              {shareChatRecipients.map((item) => (
                <Chip
                  key={item}
                  label={item}
                  onDelete={() => setShareChatRecipients(prev => prev.filter(p => p !== item))}
                />
              ))}
            </Stack>
          </Stack>
        )}
        <TextField
          label="Betreff"
          value={shareChatSubject}
          onChange={(ev) => setShareChatSubject(ev.target.value)}
          fullWidth
        />
      </Stack>
    </AppDialog>
  );
}
